import * as React from 'react';

interface ZeckitWidgetProps {
    businessId: string;
    maxWidth?: number;
}

interface ZeckitWidgetState {
    errored: boolean;
}

class ZeckitSmallWidget extends React.Component<ZeckitWidgetProps, ZeckitWidgetState> {
    constructor(props: ZeckitWidgetProps) {
      super(props);
  
      this.state = { errored: false };

      this.onError = this.onError.bind(this);
    }
  
    public render() {
            const businessId = this.props.businessId;
            const maxWidth = this.props.maxWidth || 100;
  
      return (
            !this.state.errored ? 
                <div>
                    <a href={"https://zeckit.com/selvitys/FI/" + businessId } target="_blank">
                        <img src={"https://zeckit.com/selvitys/widget/badge/FI/" + businessId + ".png"} style={{maxWidth: maxWidth + "px"}} onError={this.onError}/>
                    </a>
                </div>
            : null
      );
    }
  
    private onError() {
      if (!this.state.errored) {
        this.setState({ errored: true });
      }
    }
  }
  
export default ZeckitSmallWidget;


// WEBPACK FOOTER //
// ./src/common/ZeckitSmallWidget.tsx